var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOpen = function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.954 13.166a8.253 8.253 0 0 1 16.091 0 .75.75 0 1 0 1.463-.332C20.523 8.492 16.641 5.25 12 5.25S3.477 8.492 2.49 12.834a.75.75 0 0 0 1.463.332M12 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })));
};
export default SvgEyeOpen;